export default __webpack_public_path__ + "static/media/V210_CoC.a23e4f88.pdf";